import { useState } from 'react';

// Components
import InputText from '../../InputText';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Styles
import styles from '../../index.module.sass';
import { styled } from '@mui/material/styles';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 350,
    backgroundColor: '#002747',
  },
});

export default function Password({ contractFields, handleChange, t, typecontract }) {
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  function checkPassword() {
    const { password = '', confirmPassword = '' } = contractFields;
    if (password !== confirmPassword) setPasswordError(true);
    else setPasswordError(false);
  }

  return (
    <div className={`${styles.personal}`}>
      <div className={styles.areaName}>
        <i className={`material-icons-outlined ${styles.titleIcon}`}>password</i>
        {t('passwordTitle')}
      </div>
      <div className={styles.areaContainer}>
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type={`${(showPassword && 'text') || 'password'}`}
            placeholder={`${t('password')}*`}
            className={styles.inputText}
            onChange={handleChange}
            name='password'
            maxLength='10'
            value={contractFields?.password || ''}
            requiredText={t('required')}
            required
          />
          <div className={styles.showPassword}>
            <i
              className={`material-icons-outlined ${styles.showPasswordIcon}`}
              onClick={() => setShowPassword(!showPassword)}>
              {(showPassword === true && 'visibility_off') || 'visibility'}
            </i>
          </div>
        </div>
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type={`${(showPassword && 'text') || 'password'}`}
            placeholder={`${t('confirmPassword')}*`}
            className={styles.inputText}
            onChange={handleChange}
            onBlur={checkPassword}
            name='confirmPassword'
            maxLength='10'
            value={contractFields?.confirmPassword || ''}
            requiredText={t('required')}
            required
            error={passwordError}
            errorText={t('differentPassword')}
            setError={setPasswordError}
            disablePaste={true}
          />
        </div>
        <div className={styles.instructions}>
          <div className={styles.instructionsTitle}>{t('instructionsTitle')}</div>
          <CustomWidthTooltip
            title={
              <div className={styles.instructionsAlert}>
                <span>{t('instructions')}</span>
                <ul className={styles.instructionsList}>
                  <li>{t('dot1')}</li>
                  <li>{t('dot2')}</li>
                  <li>{t('dot3')}</li>
                  <li>{t('dot4')}</li>
                  <li>{t('dot5')}</li>
                  <li>{t('dot6')}</li>
                </ul>
              </div>
            }
            placement='right'
            arrow>
            {<span className={`material-icons-outlined ${styles.tooltip}`}>info</span>}
          </CustomWidthTooltip>
        </div>
      </div>
    </div>
  );
}
